// User connection
export const getIsOwner = (state, userId) => (
    state.userState.isConnected && state.userState.currentId === userId
);

export const getIsPrimaryUser = () => (
    window.currentUserId === '1' && window.currentUserPseudo === 'Locatipic'
);
